import React from 'react';
import  { Collapse, NavItem, NavLink } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';

class SubMenu extends React.Component {
  constructor(props) {
    super(props);

    this.toggleNavbar = this.toggleNavbar.bind(this);
     this.state = {
       collapsed: true
     };
   }

   toggleNavbar() {
     this.setState({
       collapsed: !this.state.collapsed,
     });
   }
   render() {
     const { icon, title, items ,items2} = this.props;
     return (
       <div>
         <NavItem onClick={this.toggleNavbar} className={classNames({'menu-open': !this.state.collapsed})}>
           <NavLink style={ {fontSize : 20,color: "#1a1515"} } className="dropdown-toggle" href="#"><FontAwesomeIcon icon={icon} className="mr-2"/>{title}</NavLink>
         </NavItem>
         <Collapse isOpen={!this.state.collapsed} navbar className={classNames('items-menu',{'mb-1': !this.state.collapsed})}>
           {items.map(item => (
               <NavItem key={item.title} className="pl-4">
                 <NavLink style={ {fontSize : 20,color: "#1a1515"} } href={item.link}>{item.title}</NavLink>
               </NavItem>
           ))}
         </Collapse>
       </div>
     );
   }
}

export default SubMenu;
